export const iconFontAwesomeMaritimeAnchorCircleCheck = (
	<i className="fa-solid fa-anchor-circle-check"></i>
);
